var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 17.166C2 17.5697 2.24274 17.9338 2.61538 18.0891L11.2499 21.6868V10.8292L6.20914 8.69052L2 6.93671V17.166ZM3.02517 5.73886L6.49364 7.18406L15.2775 3.36498L12.7692 2.31986C12.2769 2.11473 11.7231 2.11473 11.2308 2.31986L3.02517 5.73886ZM17.1985 4.1654L8.40027 7.99073L11.9947 9.51574L20.7773 5.65657L17.1985 4.1654ZM22 6.75773L12.7499 10.8223V21.6869L21.3846 18.0891C21.7573 17.9338 22 17.5697 22 17.166V6.75773Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimButtonIcon);
export default __webpack_public_path__ + "static/media/claim-button-icon.dd90e46ae7aee946499d08fab36a0fe2.svg";
export { ForwardRef as ReactComponent };